import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
// import 'ant-design-vue/dist/antd.css';
import router from './router'
import store from './store'
import baseAPI from './baseAPI/axiosApi'
import PublicJs from './assets/js/public'
import './assets/css/antd.css'
import './assets/iconfont/iconfont.css'
import './assets/css/public.css'
import "babel-polyfill";
import { getNav } from '@/baseAPI/nav'
import SockJS from  'sockjs-client';
import Stomp from 'stompjs';
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.config.productionTip = false
Vue.prototype.baseAPI= baseAPI
Vue.prototype.SockJS=SockJS
Vue.prototype.Stomp=Stomp

Vue.use(Antd);
Vue.use(PublicJs);
Vue.use(Vant);

// 引入视频插件
import VideoPlayer from 'vue-video-player' 
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer);

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch(err => err);
}

// 判定是否登录
router.beforeEach((to,from,next) => {
  if (to.meta.title) {
    document.title = store.state.title+'-'+to.meta.title
  }
  if (store.state.access_token!=''&&router.options.routes[4].children.length==0) {
    getNav().then(res =>{
      console.log(res)
      var pathArr=router.options.routes;
      pathArr[4].children=forRrouter(res.data);
      pathArr.push({
        path: '/',
        redirect: pathArr[4].children[0].path, 
      })
      router.addRoutes(pathArr)
      var url=isLogin(to)
      if(typeof to.redirectedFrom!='undefined'){
        url=to.redirectedFrom
      }
      if(url==''){
        next()
      }else{
        next(url)
      }
    })
  }else{
    var url=isLogin(to)
    if(url==''){
      next()
    }else{
      next(url)
    }
}
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

function isLogin(to){
  // 判断该路由是否需要登录权限
  if(to.path!='/login'){
    // 判断token是否存在
    if (store.state.access_token!='') {
      return ''
    } else {
      if(to.fullPath!='/404'){
        return '/login?path='+to.fullPath
      }else{
        return '/login'
      }
    }
  }else{
    if (store.state.access_token!='') {
      return '/'
    }else{
      return ''
    }
  }
}
function forRrouter(arr){
  var routerArr=[];
  var noUrl=[];
  for(let i=0;i<arr.length;i++){
    var obj={
        path: '/admin'+arr[i].url,
        ico:arr[i].ico,
        name:arr[i].name,
        meta:{
            type:'login',    //是否需要登录权限
            keepAlive: arr[i].description == 'keepAlive'? true:false, //是否缓存此组件
            title:arr[i].name
        },
        children: [],
    };
    if(arr[i].parentId!='0'&&arr[i].children==null){
        var isEmpty=true;
        for(let i=0;i<noUrl.length;i++){
            if(arr[i].url.indexOf(noUrl[i])>-1){
                isEmpty=false;
                break;
            }
        }
        if(isEmpty){
            obj.component=() => import('@/components'+arr[i].url+'.vue');
        }else{
            obj.component=() => import('@/empty.vue');
        }
    }else{
      obj.component=() => import('./myView.vue');
    }
    if(arr[i].children!=null){
      obj.children=forRrouter(arr[i].children)
    }
    routerArr.push(obj)
  }
  return routerArr
}
